import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/faq/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/components/partials/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/header/course-header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/lesson-navigation/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/download-certificate/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/log-out-confirmation/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/training-slot/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/verification-link-sent/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/components/partials/provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/session-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/video-player/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/var/www/basic-traning-frontend/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogContent","DialogTitle"] */ "/var/www/basic-traning-frontend/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Drawer","DrawerContent"] */ "/var/www/basic-traning-frontend/components/ui/drawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatProvider"] */ "/var/www/basic-traning-frontend/context/ChatContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/basic-traning-frontend/node_modules/next/dist/client/image-component.js");
